import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@mui/material'
import css from './ModalCamposRequeridosFicha.module.css'

const FIELDS = [
  { key: 'fechaNacimiento', label: 'Fecha de Nacimiento' },
  { key: 'telefonos', label: 'Teléfono de contacto' },
  { key: 'dni', label: 'DNI' },
  { key: 'emails', label: 'Email' },
  { key: 'codigoPostal', label: 'Código Postal' },
  { key: 'facturacion', label: 'Datos para facturas' },
  { key: 'condicionesUrl', label: 'Firma de Condiciones' },
  { key: 'rgpdUrl', label: 'Firma de RGPD' }
]

const EmptyStatus = () => (
  <i className={`material-icons ${css.iconClose}`}>close</i>
)

const checkField = (field, alumno) => {
  if (field === 'fechaNacimiento') return !!alumno.fechaNacimiento
  if (field === 'telefonos') return alumno.telefonos.length > 0
  if (field === 'dni') return !!alumno.dni
  if (field === 'emails') return alumno.emails?.length > 0
  if (field === 'codigoPostal') return !!alumno.codigoPostal
  if (field === 'facturacion')
    return !!(
      alumno.facturacion &&
      alumno.facturacion.identifcacion &&
      alumno.facturacion.nombre
    )
  if (field === 'condicionesUrl') return !!alumno.condicionesUrl
  if (field === 'rgpdUrl') return !!alumno.rgpdUrl
}

const ModalCamposRequeridosFicha = ({ open, alumno, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Ficha de {alumno.nombre}</DialogTitle>
    <DialogContent className={css.content}>
      <Table size='small'>
        <TableHead>
          <TableCell>Campo</TableCell>
          <TableCell>Estado</TableCell>
        </TableHead>
        <TableBody>
          {FIELDS.map(({ key, label }) => (
            <TableRow key={key}>
              <TableCell>{label}</TableCell>
              <TableCell>
                {checkField(key, alumno) ? (
                  <i className={`material-icons ${css.iconOk}`}>check</i>
                ) : (
                  <EmptyStatus />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color='secondary'>
        Cerrar
      </Button>
    </DialogActions>
  </Dialog>
)

export default ModalCamposRequeridosFicha
